import { render, staticRenderFns } from "./CoverLetter_1.vue?vue&type=template&id=cb893752&"
import script from "./CoverLetter_1.vue?vue&type=script&lang=js&"
export * from "./CoverLetter_1.vue?vue&type=script&lang=js&"
import style0 from "./CoverLetter_1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports